export default __webpack_public_path__ + "alberta-plus.68c5306ecb7d0da14af2.svg";